import { render, staticRenderFns } from "./HubungiKami.vue?vue&type=template&id=f30e9e24"
import script from "./HubungiKami.vue?vue&type=script&lang=js"
export * from "./HubungiKami.vue?vue&type=script&lang=js"
import style0 from "./HubungiKami.vue?vue&type=style&index=0&id=f30e9e24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports